import type {
  EditTripSegment,
  EditTripStep,
} from '@apps/main/new-desktop/modules/editTripModal';
import type { RoomPaxConfig } from '@apps/main/new-desktop/modules/paxSelector';

export enum TabKey {
  None = 'none',
  Pax = 'pax',
  Calendar = 'calendar',
  Itinerary = 'itinerary',
  Airplane = 'airplane',
}

export interface ConfigurationPanelPaxDetails {
  title: string;
  initialPaxes: RoomPaxConfig[];
  shouldShowTicketsWarning: boolean;
  shouldShowRoomSelectionWarning: boolean;
  shouldShowNumberOfVehiclesUpdatedWarning: boolean;
  shouldShowNumberOfVehiclesWillBeUpdatedWarning: boolean;
}
export interface ConfigurationEditCarTripDetails {
  segments: EditTripSegment[];
  initialStep: EditTripStep;
}

export interface ConfigurationEditTripDetails {
  segments: EditTripSegment[];
  isDesktop: boolean;
  initialStep: EditTripStep;
}
